<!--
 * @Author: your name
 * @Date: 2020-10-30 14:18:30
 * @LastEditTime: 2020-11-04 10:45:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-gaokao-ebook\src\components\layout\tfedu_common.vue
-->
<template>
  <div class="tfedu-layout">
    <!-- <div class="tfedu-top">
      <layout-header></layout-header>
    </div> -->
    <div :class="['tfedu-nav', { 'home': showBg }]" ref="tfedu-nav-box">
      <div class="tfedu-nav-box">
				<router-view :key="$route.fullPath"></router-view>
			</div>
    </div>
    <!-- <div class="tfedu-bottom">
      <layout-footer></layout-footer>
    </div> -->
  </div>
</template>
<script>
import layoutHeader from "@/components/header/header";
import layoutFooter from "@/components/footer/footer";
export default {
  data() {
    return {
      showBg: false
    }
  },
  components: {
    layoutHeader,
    layoutFooter,
  },
  created() {
    let pat = new RegExp('home');
    if(pat.test(this.$route.path)) {
      this.showBg = true
    } else {
      this.showBg = false
    } 
  },
  mounted() {
    this.$root.eventHub.$on("subject-scroll-top", () => {
      this.$refs['tfedu-nav-box'].scrollTop = 0
    })
  }
};
</script>
<style lang="stylus" scoped>
.tfedu-layout {
  height: 100%;
  overflow: hidden;
}

.tfedu-top, .tfedu-nav, .tfedu-bottom {
  width: 100%;
  position: absolute;
}

.tfedu-top {
  height: 1px;
  top: 0;
}

.tfedu-nav {
  top: 1px;
  bottom: 1px;
  width: 100%;
	overflow-x: hidden;
  overflow-y: auto;
  background-color: #f5f5f5;

  .tfedu-nav-box {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }

  .tfedu-nav-box::-webkit-scrollbar {
    display: none;
  }
}

.tfedu-bottom {
  height: 43px;
  height: auto;
  bottom: 0;
}

.home {
  background: url('../../assets/images/home/bg.png') no-repeat;
  background-size: 100% 100%;
}
</style>